const BoxSwitch = ({ onLabel, offLabel, onToggle, background, isOn }) => {
  const buttonStyle = {
    flexGrow: 1,
    borderRadius: "5px",
    padding: "10px",
    textAlign: "center",
    background: "none",
  };
  const activeButtonStyle = { ...buttonStyle, background };
  return (
    <div
      onClick={() => {
        onToggle(!isOn);
      }}
      style={{
        cursor: "pointer",
        fontFamily: "MTNRegular",
        color: "#fff",
        display: "flex",
        width: "230px",
        margin: "0 auto",
        borderRadius: "5px",
        fontSize: "12px",
        background: "rgba(0,0,0,0.6)",
        padding: "3px",
      }}
    >
      <div style={isOn ? activeButtonStyle : buttonStyle}>{onLabel}</div>
      <div style={!isOn ? activeButtonStyle : buttonStyle}>{offLabel}</div>
    </div>
  );
};
export default BoxSwitch;
